<div id="pause-subscription">
  <div class="main_profile">

    <!-- HEADER -->
    <div class="modal-header switch_header">
      <ng-container>
        <div class="col-lg-12 col-xl-12 col-12">
          <h3 class="profile_name pl-lg-2 pt-lg-2 pb-2 offset-0">
            Pause Subscription
          </h3>
        </div>
      </ng-container>
    </div>

    <!-- BODY -->
    <div class="modal-body bg-white body-content">
      <ng-container>
        <div class="row">
          <div class="col-lg-12 col-xl-12 col-12">
            <h3 class="profile_body pl-lg-2 pt-lg-2 pb-2 offset-0">

              <form [formGroup]="pauseForm" class="form-group">

                <!-- Duration -->
                <div class="form-group row padding-m">
                  <label class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 col-form-label table-heading">
                    Duration: <span class="text-danger">*</span>
                  </label>

                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <input
                      class="form-control"
                      type="number"
                      formControlName="duration"
                      name="duration"
                      id="duration"
                      min="1"
                      [max]="currentMax"
                      title="Pause duration"
                    />

                    <span class="end_after_error" *ngIf="durationCtrl?.touched && durationCtrl?.invalid">
                      {{ getDurationError() }}
                    </span>
                  </div>
                </div>

                <!-- Unit -->
                <div class="form-group row padding-m">
                  <label class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 col-form-label table-heading">
                    Unit: <span class="text-danger">*</span>
                  </label>

                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <select
                      class="form-control"
                      formControlName="unit"
                      name="unit"
                      id="unit"
                      title="Pause unit"
                    >
                      <option *ngFor="let u of units" [value]="u.value">
                        {{ u.label }}
                      </option>
                    </select>

                    <span class="end_after_error" *ngIf="unitCtrl?.touched && unitCtrl?.invalid">
                      {{ getUnitError() }}
                    </span>
                  </div>
                </div>

                <!-- Info -->
                <div class="form-group row padding-m">
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12"></div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <span class="info_caption">
                      Billing will be suspended during the pause period.
                    </span>
                    <br/>
                    <span class="info_caption" *ngIf="data?.nextChargeDateLabel">
                      Customer will be charged again on:
                      <strong>{{ data.nextChargeDateLabel }}</strong>
                    </span>
                  </div>
                </div>


              </form>

            </h3>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="dropdown-footer">
    <div class="row">
      <div class="col-sm-4 col-6 pl-xl-4 pl-lg-4 offset-4">
        <button class="btn btn-outline-secondary lg-btn cancel_btn" (click)="closeAction()">
          Cancel
        </button>
      </div>
      <div class="col-sm-4 col-6">
        <button class="btn btn-default lg-btn ok-btn" (click)="saveAction()">
          OK
        </button>
      </div>
    </div>
  </div>
</div>
